"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const react_redux_1 = require("react-redux");
const App_1 = __importDefault(require("./App"));
const state_1 = __importDefault(require("./state"));
ReactDOM.render(React.createElement(react_redux_1.Provider, { store: state_1.default },
    React.createElement(App_1.default, null)), document.getElementById("root"));
